// extracted by mini-css-extract-plugin
module.exports = {"container":"DestinationPracticalInformationArticle_container__mPspP","articleHead":"DestinationPracticalInformationArticle_articleHead__JBZIg"};